import * as React from "react";
import { Link } from 'gatsby';
import { Container, Navbar, Row, Col, Image, Accordion } from 'react-bootstrap';

import logo from '../images/green-logo.svg';

// import ModalPopup from "./modal-popup";
const footedata = [
  {
    title: "Company",
    list: [
      {
        linktext: "Our Story",
        link: "/our-story.html",
      },
      {
        linktext: "Process",
        link: "/process.html",
      },
      {
        linktext: "Engagement Model",
        link: "/engagement-model.html",
      },      
      {
        linktext: "Blog",
        link: "/blog.html",
      },
      {
        linktext: "Contact Us",
        link: "/request-quote.html",
      },
    ]

  },
  {
    title: "Why Peerbits",
    list: [
      {
        linktext: "Case Study",
        link: "/works.html",
      },
      {
        linktext: "Testimonials",
        link: "/testimonials.html",
      },
      {
        linktext: "Life @ Peerbits",
        link: "/life-at-peerbits.html",
      },
      {
        linktext: "Resources",
        link: "/resources.html",
      },            
      {
        linktext: "Careers",
        link: "/careers.html",
      },
      {
        linktext: "Our Clients",
        link: "/our-clients.html",
      },
    ]

  },
  {
    title: "Services",
    list: [
      // {
      //   linktext: "Software development",
      //   link: "/software-development-services.html",
      // },
      {
        linktext: "Cloud Consulting",
        link: "/cloud-services-and-solutions.html",
      },
      {
        linktext: "Resource as a Service",
        link: "/hire-dedicated-developers.html",
      },
      {
        linktext: "DevOps Services",
        link: "/devops-services.html",
      },
      {
        linktext: "IoT (Internet of Things)",
        link: "/internet-of-things-iot-applications-development-company.html",
      },
      {
        linktext: "Product Engineering",
        link: "/product-engineering-services.html",
      },
      {
        linktext: "Digital Transformation",
        link: "/digital-transformation.html",
      },

    ]

  }
]
const Footer = () => (
  <>
    <footer className="section footer pb-0">
      <div className="footer-top py-5">
        <Container>
          <Row xs={1} sm={1} md={3} lg={5} className="justify-content-between g-4">
            <Col md={12} sm={12}>
              <div className="footer-about-us">
                <div className="mb-4">
                  <Navbar.Brand>
                    <Link to="/">
                      <Image loading="lazy" className="lazyload" src={logo} width={144} height={34} alt="logo" />
                    </Link>
                  </Navbar.Brand>
                </div>
                <p className="me-5 mb-4 fw-normal">Delivering excellence, righteously</p>
              </div>
            </Col>
            {
              footedata?.map((item, index) => (
                <Col key={index} className="d-none d-md-block">
                  <h4 className="text-white mb-4">{item.title}</h4>
                  <ul className="list-unstyled footer-menu">
                    {
                      item.list.map((item, index) => (
                        <li key={index}><Link to={item.link}>{item.linktext}</Link></li>
                      ))
                    }
                  </ul>
                </Col>
              ))
            }
            <Col className="d-block d-md-none footer-accordian">
              <Accordion defaultActiveKey="0">
                {footedata.map((item, index) => (
                  <Accordion.Item key={index} eventKey={index}>
                    <Accordion.Header><h3 className="h4 text-white mb-0">{item.title}</h3></Accordion.Header>
                    <Accordion.Body>
                      <ul className="list-unstyled footer-menu mb-0">
                        {
                          item.list.map((item, index) => (
                            <li key={index}><Link to={item.link}>{item.linktext}</Link></li>
                          ))
                        }
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
            <Col>
              <h4 className="text-white mb-4">Have Questions?</h4>
              <ul className="list-unstyled footer-menu">
                {/* <li><a href='skype:enquiry.peerbits?chat'><i className="zmdi zmdi-skype zmdi-hc-fw text-primary"></i> enquiry.peerbits</a></li> */}
                <li><a href='mailto:info@peerbits.com'><i className="zmdi zmdi-email zmdi-hc-fw text-primary"></i> info@peerbits.com</a></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="copyrights">
        <Container>
          <div className="d-md-flex align-items-center py-4 border-top text-center text-md-start">
            <p className="text-white opacity-50 mb-md-0 font-size-12">Copyright 2011-2025 Peerbits All rights reserved.</p>
            <div className="social-icon d-flex ms-auto justify-content-center">
              <a href="https://www.facebook.com/Peerbits/" aria-label="facebook" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-facebook"></i></a>
              <a href="https://twitter.com/Peerbits" aria-label="twitter" rel="noreferrer" target="_blank" style={{ lineHeight: "26px" }}>
                <svg width={14} height={14} aria-hidden="true" focusable="false" data-prefix="fab" data-icon="x-twitter" className="svg-inline--fa fa-x-twitter " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
              </a>
              <a href="https://www.linkedin.com/company/peerbits" aria-label="linkedin" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-linkedin"></i></a>
              <a href="https://www.pinterest.com/peerbits/" aria-label="pinterest" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-pinterest"></i></a>
              <a href="https://dribbble.com/peerbits" aria-label="dribbble" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-dribbble"></i></a>
              <a href="https://instagram.com/peerbits/" aria-label="instagram" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-instagram"></i></a>
              <a href="https://www.youtube.com/channel/UCUXKhs5ZUCYA-bUOgNh9sBg" aria-label="youtube" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-youtube-play"></i></a>
            </div>
          </div>
        </Container>
      </div>
    </footer>

    {/* <ModalPopup /> */}

  </>
)

export default Footer;
